function initializeProductVariations(stayOnPage) {
  const customCursor = document.querySelector('custom-cursor');
  if (customCursor) {
    customCursor.remove();
  }

  if (!document.getElementById('video-popup-container')) {
    const videoPopup = document.createElement('div');
    videoPopup.id = 'video-popup-container';
    videoPopup.innerHTML = `
      <div id="video-popup" class="video-popup">
        <div class="video-popup-content">
          <span class="close-video">&times;</span>
          <video id="popup-video" controls>
            <source src="https://cdn.shopify.com/videos/c/o/v/dc48be92657b47d6ac29ee69126db177.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    `;
    document.body.appendChild(videoPopup);

    const style = document.createElement('style');
    style.textContent = `
      .video-popup {
        display: none;
        position: fixed;
        z-index: 9999;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0,0,0,0.8);
        align-items: center;
        justify-content: center;
      }
      .video-popup-content {
        position: relative;
        margin: auto;
        width: 90%;
        max-width: 800px;
  }

      #popup-video {
        width: 100%;
        height: auto;
      }
      .video-thumbnail {
        position: absolute;
        top: 10px;
        right: 10px;
        max-width: 127px;
        max-height: 125px;
        cursor: pointer;
        overflow: hidden;
        z-index: 1;
      }
      
      @media (max-width: 991px) {
        .video-thumbnail {
          top: auto;
          bottom: 10px;
          max-width: 83px;
          max-height: 84px;
        }
      }
      
      .video-thumbnail img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .video-thumbnail::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    `;
    document.head.appendChild(style);

    const popup = document.getElementById('video-popup');
    const closeBtn = document.querySelector('.close-video');
    const video = document.getElementById('popup-video');

    window.openVideoPopup = function () {
      popup.style.display = 'flex';
      video.play();
    };

    closeBtn.addEventListener('click', function () {
      popup.style.display = 'none';
      video.pause();
    });

    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        popup.style.display = 'none';
        video.pause();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        popup.style.display = 'none';
        video.pause();
      }
    });
  }

  const imageSets = {
    'shakti-mat-premium-amber-orange': [
      "https://cdn.shopify.com/s/files/1/1575/4475/files/First_image.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/2_1.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/7_1.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/3_1.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/4_1.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/12_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/5_1.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/6_1.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/8_1.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/9_1.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/10_1.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/11_1.png"
    ],
    'shakti-mat-premium-mondstein': [
      "https://cdn.shopify.com/s/files/1/1575/4475/files/First_image_1.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/8_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/3_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/4_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/5_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/6_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/7_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/14_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/10_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/9_2.png"
    ],
    'shakti-mat-premium-onyxschwarz': [
      "https://cdn.shopify.com/s/files/1/1575/4475/files/First_image_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/13_4.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/3_3.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/4_3.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/5_3.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/6_3.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/7_3.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/15_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/8_3.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/9_3.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/10_4.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/12_4.png"
    ],
    'shakti-mat-premium-salbeigrun': [
      "https://cdn.shopify.com/s/files/1/1575/4475/files/First_image_3.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/8_4.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/3_4.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/4_4.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/5_4.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/6_4.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/7_5.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/13_5.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/14_4.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/16_2.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/9_5.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/10_5.png"
    ],
    'shakti-mat-premium-sandstein': [
      "https://cdn.shopify.com/s/files/1/1575/4475/files/First_image_4.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/13_6.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/3_5.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/4_5.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/5_5.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/14_5.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/6_5.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/7_7.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/8_5.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/9_6.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/10_6.png",
      "https://cdn.shopify.com/s/files/1/1575/4475/files/11_3.png"
    ]
  };

  const swatchLinks = document.querySelectorAll('.color-swatch[href], .block-swatch[href]');

  function updateGalleryWithCustomImages(productHandle, product) {
    const galleryContainer = document.querySelector('.product-gallery__media-list');
    if (!galleryContainer) {
      console.error('Gallery container not found');
      return;
    }

    let customImages = [];
    let matchFound = false;

    for (const handle in imageSets) {
      if (productHandle === handle) {
        customImages = imageSets[handle];
        matchFound = true;
        break;
      }
    }

    if (!matchFound) {
      for (const handle in imageSets) {
        if (productHandle.includes(handle)) {
          customImages = imageSets[handle];
          matchFound = true;
          break;
        }
      }
    }

    if (!matchFound) {
      const productColor = productHandle.split('-').pop();
      for (const handle in imageSets) {
        if (handle.includes(productColor)) {
          customImages = imageSets[handle];
          matchFound = true;
          break;
        }
      }
    }

    if (customImages.length > 0) {
      const mediaItems = customImages.map((src, index) => {
        const isFirstImage = index === 0;
        return `
          <div class="product-gallery__media snap-center${isFirstImage ? ' is-selected' : ''}" data-media-type="image" data-media-id="${index}" style="${isFirstImage ? 'display: block; position: relative; opacity: 1;' : ''}">
            <img src="${src}" 
                 alt="${product?.title || 'Product Image'}"
                 class="product-gallery__image"
                 loading="${isFirstImage ? 'eager' : 'lazy'}"
                 fetchpriority="${isFirstImage ? 'high' : 'auto'}"
                 data-media-id="${index}"
                 data-width="2000"
                 data-height="2000"
                 sizes="(max-width: 740px) calc(100vw - 40px), (max-width: 999px) calc(100vw - 64px), min(760px, 42vw)">
          </div>
        `;
      }).join('');

      galleryContainer.innerHTML = mediaItems;

      const firstImageContainer = galleryContainer.querySelector('.product-gallery__media.is-selected');
      if (firstImageContainer) {
        const videoThumbnail = document.createElement('div');
        videoThumbnail.className = 'video-thumbnail';
        videoThumbnail.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/1575/4475/files/Video-sm-002.png?v=1742682447" alt="Watch Video">`;
        videoThumbnail.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          window.openVideoPopup();
        });
        firstImageContainer.style.position = 'relative';
        firstImageContainer.appendChild(videoThumbnail);
      } else {
        console.error('First image container not found');
      }

      const thumbnailList = document.querySelector('.product-gallery__thumbnail-list');
      if (thumbnailList) {
        const thumbnailItems = customImages.map((src, index) => {
          const isFirstImage = index === 0;
          return `
            <button type="button" class="product-gallery__thumbnail${isFirstImage ? ' is-selected' : ''}" data-media-id="${index}" aria-label="Gehe zu Element ${index}">
              <img src="${src}" 
                   alt="${product?.title || 'Product Image'}"
                   loading="${isFirstImage ? 'eager' : 'lazy'}"
                   fetchpriority="${isFirstImage ? 'high' : 'auto'}"
                   data-width="192"
                   data-height="192"
                   sizes="(max-width: 699px) 56px, 64px">
            </button>
          `;
        }).join('');

        thumbnailList.innerHTML = thumbnailItems;
        
        const thumbnails = thumbnailList.querySelectorAll('.product-gallery__thumbnail');
        const mediaElements = galleryContainer.querySelectorAll('.product-gallery__media');
        
        thumbnails.forEach((button, index) => {
          
          button.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const mediaItems = document.querySelectorAll('.product-gallery__media');
            const thumbnailButtons = document.querySelectorAll('.product-gallery__thumbnail');
            
            mediaItems.forEach(item => {
              item.style.display = 'none';
              item.classList.remove('is-selected');
            });
            
            thumbnailButtons.forEach(btn => {
              btn.classList.remove('is-selected');
              btn.setAttribute('aria-current', 'false');
            });
            
            if (mediaItems[index]) {
              const selectedMedia = mediaItems[index];
              selectedMedia.style.display = 'block';
              selectedMedia.classList.add('is-selected');
              selectedMedia.style.opacity = '1';
              selectedMedia.style.position = 'relative';
              
              if (stayOnPage) {
                selectedMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
              }
            }
            
            button.classList.add('is-selected');
            button.setAttribute('aria-current', 'true');
            
            const mediaCarousel = document.querySelector('media-carousel');
            if (mediaCarousel && typeof mediaCarousel.select === 'function') {
              mediaCarousel.setAttribute('initial-index', index.toString());
              try {
                mediaCarousel.select(index, { animate: true });
              } catch(err) {
                console.error('Error calling mediaCarousel.select:', err);
              }
            }
            
            return false;
          };
          
          button.style.cursor = 'pointer';
          button.style.position = 'relative';
        });
        
        thumbnails.forEach((thumbnail, i) => {
          const thumbnailId = thumbnail.getAttribute('data-media-id');
          const mediaId = mediaElements[i]?.getAttribute('data-media-id');
        });
      } else {
        console.error('Thumbnail list container not found');
      }

      return true;
    } else {
      console.warn('No custom images found for handle:', productHandle);
    }

    return false;
  }

  function loadInitialImages() {
    const selectedSwatch = document.querySelector('.color-swatch.is-selected[href], .block-swatch.is-selected[href]');

    let productHandle;
    if (selectedSwatch) {
      const productUrl = selectedSwatch.getAttribute('href');
      productHandle = productUrl.split('/').pop();
    } else {
      const currentProductUrl = window.location.pathname;
      productHandle = currentProductUrl.split('/').pop();

      const matchingSwatch = Array.from(swatchLinks).find(swatch => {
        const swatchUrl = swatch.getAttribute('href');
        const swatchHandle = swatchUrl.split('/').pop();
        return productHandle.includes(swatchHandle) || swatchHandle.includes(productHandle);
      });

      if (matchingSwatch) {
        matchingSwatch.classList.add('is-selected');
        productHandle = matchingSwatch.getAttribute('href').split('/').pop();
      } else if (swatchLinks.length > 0) {
        swatchLinks[0].classList.add('is-selected');
        const productUrl = swatchLinks[0].getAttribute('href');
        productHandle = productUrl.split('/').pop();
      }
    }

    fetch('/products/' + productHandle + '.js')
      .then(response => response.json())
      .then(product => {
        updateGalleryWithCustomImages(productHandle, product);
        initCarousel();
      })
      .catch(error => {
        console.error('Error fetching initial product data:', error);
      });
  }

  function initCarousel() {
    const mediaCarousel = document.querySelector('media-carousel');
    if (mediaCarousel) {
      const style = document.createElement('style');
      style.textContent = `
        .product-gallery__media {
          opacity: 0;
          transition: opacity 0.3s ease-in-out;
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        }
        .product-gallery__media.is-selected {
          opacity: 1;
          position: relative;
        }
        .product-gallery__media-list {
          position: relative;
        }
      `;
      document.head.appendChild(style);

      setTimeout(() => {
        if (typeof mediaCarousel.initialize === 'function') {
          mediaCarousel.initialize();
        } else {
          console.warn('mediaCarousel.initialize is not a function');
        }

        const thumbnailButtons = document.querySelectorAll('.product-gallery__thumbnail');
        const mediaItems = document.querySelectorAll('.product-gallery__media');
        
        if (thumbnailButtons.length === 0 || mediaItems.length === 0) {
          console.error('No thumbnails or media items found. This will cause the carousel to malfunction.');
        }
        
        let currentIndex = 0;

        const updateSelection = (index) => {
          
          mediaItems.forEach(item => {
            if (item.classList.contains('is-selected')) {
              item.style.opacity = '0';
            }
          });

          thumbnailButtons.forEach(btn => {
            btn.classList.remove('is-selected');
            btn.setAttribute('aria-current', 'false');
          });

          setTimeout(() => {
            mediaItems.forEach(item => item.classList.remove('is-selected'));

            if (mediaItems[index]) {
              const selectedMedia = mediaItems[index];
              selectedMedia.classList.add('is-selected');
              selectedMedia.style.opacity = '1';
              
              if (stayOnPage) {
                selectedMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
              }
              selectedMedia.dispatchEvent(new CustomEvent('media:selected', { bubbles: true }));
            } else {
              console.error('No media item found at index:', index);
            }

            if (thumbnailButtons[index]) {
              thumbnailButtons[index].classList.add('is-selected');
              thumbnailButtons[index].setAttribute('aria-current', 'true');

              const thumbnailList = document.querySelector('.product-gallery__thumbnail-list');
              if (thumbnailList) {
                const thumbnail = thumbnailButtons[index];
                const thumbnailRect = thumbnail.getBoundingClientRect();
                const listRect = thumbnailList.getBoundingClientRect();

                if (thumbnailRect.right > listRect.right || thumbnailRect.left < listRect.left) {
                  let scrollOffset;
                  if (index >= thumbnailButtons.length - 1) {
                    const secondToLastThumbnail = thumbnailButtons[thumbnailButtons.length - 2];
                    scrollOffset = secondToLastThumbnail.offsetLeft - (thumbnailList.clientWidth - secondToLastThumbnail.clientWidth - thumbnail.clientWidth);
                  } else {
                    scrollOffset = thumbnail.offsetLeft - (thumbnailList.clientWidth / 2) + (thumbnail.clientWidth / 2);
                  }
                  if (stayOnPage) {
                    thumbnailList.scrollTo({
                      left: scrollOffset,
                      behavior: 'smooth'
                    });
                  }
                }
              }
            } else {
              console.error('No thumbnail button found at index:', index);
            }
            
            currentIndex = index;
            mediaCarousel.setAttribute('initial-index', index.toString());
            
            if (mediaCarousel.select && typeof mediaCarousel.select === 'function') {
              mediaCarousel.select(index, { animate: true });
            } else {
              console.error('mediaCarousel.select is not a function or not available');
            }
          }, 300);
        };

        thumbnailButtons.forEach((button, index) => {

          button.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const mediaItems = document.querySelectorAll('.product-gallery__media');
            const thumbnailButtons = document.querySelectorAll('.product-gallery__thumbnail');
            
            mediaItems.forEach(item => {
              item.style.display = 'none';
              item.classList.remove('is-selected');
            });
            
            thumbnailButtons.forEach(btn => {
              btn.classList.remove('is-selected');
              btn.setAttribute('aria-current', 'false');
            });
            
            if (mediaItems[index]) {
              const selectedMedia = mediaItems[index];
              selectedMedia.style.display = 'block';
              selectedMedia.classList.add('is-selected');
              selectedMedia.style.opacity = '1';
              selectedMedia.style.position = 'relative';
              
              if (stayOnPage) {
                selectedMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
              }
            }
            
            button.classList.add('is-selected');
            button.setAttribute('aria-current', 'true');
            
            const mediaCarousel = document.querySelector('media-carousel');
            if (mediaCarousel && typeof mediaCarousel.select === 'function') {
              mediaCarousel.setAttribute('initial-index', index.toString());
              try {
                mediaCarousel.select(index, { animate: true });
              } catch(err) {
                console.error('Error calling mediaCarousel.select:', err);
              }
            }
            
            return false;
          };
          
          button.style.cursor = 'pointer';
          button.style.position = 'relative';
        });
        

        let startX = 0;
        let startY = 0;
        let isSwiping = false;

        mediaCarousel.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          isSwiping = true;
        }, { passive: true });

        mediaCarousel.addEventListener('touchmove', (e) => {
          if (!isSwiping) return;

          const diffX = startX - e.touches[0].clientX;
          const diffY = Math.abs(startY - e.touches[0].clientY);

          if (diffY > Math.abs(diffX)) {
            isSwiping = false;
          }
        }, { passive: true });

        mediaCarousel.addEventListener('touchend', (e) => {
          if (!isSwiping) return;

          const diffX = startX - e.changedTouches[0].clientX;
          const threshold = 50;

          if (Math.abs(diffX) > threshold) {
            let newIndex = currentIndex;
            if (diffX > 0 && currentIndex < mediaItems.length - 1) {
              newIndex++;
            } else if (diffX < 0 && currentIndex > 0) {
              newIndex--;
            }
            updateSelection(newIndex);
          }

          isSwiping = false;
        }, { passive: true });

        window.dispatchEvent(new Event('resize'));

        updateSelection(0);
      }, 100);
    }
  }

  loadInitialImages();

  if (swatchLinks[0]) {
    const firstColor = swatchLinks[0].getAttribute('href').split('/').pop();
    let defaultImages = [];

    for (const handle in imageSets) {
      if (firstColor.includes(handle) || handle.includes(firstColor)) {
        defaultImages = imageSets[handle];
        break;
      }
    }

    if (defaultImages.length > 0) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = defaultImages[0];
      document.head.appendChild(link);
    }
  }

  function generateSrcSet(src) {
    if (src.includes('/files/')) {
      return src + ' 2000w';
    }

    const widths = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800, 2000];
    return widths.map(w => `${src}&width=${w} ${w}w`).join(', ');
  }

  function generateThumbnailSrcSet(src) {
    if (src.includes('/files/')) {
      return src + ' 192w';
    }

    const widths = [56, 64, 112, 128, 168, 192];
    return widths.map(w => `${src}&width=${w} ${w}w`).join(', ');
  }

  const swatchContainer = swatchLinks[0]?.parentElement;
  if (swatchContainer) {
    function handleSwatchChange(swatch) {
      const productUrl = swatch.getAttribute('href');
      const productHandle = productUrl.split('/').pop();

      const swatchContainer = swatch.closest('.variant-picker__option-values');
      if (swatchContainer) {
        swatchContainer.querySelectorAll('.color-swatch, .block-swatch').forEach(s => {
          s.classList.remove('is-selected');
        });
      }
      
      swatch.classList.add('is-selected');

      const colorTitleElement = swatch.closest('.variant-picker__option').querySelector('.variant-picker__option-info .font--bold');
      if (colorTitleElement) {
        const srOnlyElement = swatch.querySelector('.sr-only');
        const colorValue = srOnlyElement ? srOnlyElement.textContent : 
                         (swatch.getAttribute('data-option-value') || swatch.textContent.trim());
        if (colorValue) {
          colorTitleElement.textContent = colorValue;
        }
      }

      fetch('/products/' + productHandle + '.js')
        .then(response => {
          return response.json();
        })
        .then(product => {
          const imagesUpdated = updateGalleryWithCustomImages(productHandle, product);
          if (!imagesUpdated && product.media) {
            const mediaItems = product.media.map((media, index) => {
              if (media.media_type === 'image') {
                const isFirstImage = index === 0;
                return `
                  <div class="product-gallery__media snap-center${isFirstImage ? ' is-selected' : ''}" data-media-type="image" data-media-id="${media.id}">
                    <img src="${media.src}" 
                         alt="${media.alt || product.title}"
                         class="product-gallery__image"
                         loading="${isFirstImage ? 'eager' : 'lazy'}"
                         fetchpriority="${isFirstImage ? 'high' : 'auto'}"
                         data-media-id="${media.id}"
                         data-width="${media.width}"
                         data-height="${media.height}"
                         sizes="(max-width: 740px) calc(100vw - 40px), (max-width: 999px) calc(100vw - 64px), min(760px, 42vw)"
                         srcset="${generateSrcSet(media.src)}">
                  </div>
                `;
              }
              return '';
            }).join('');

            const galleryContainer = document.querySelector('.product-gallery__media-list');
            galleryContainer.innerHTML = mediaItems;

            const thumbnailList = document.querySelector('.product-gallery__thumbnail-list');
            if (thumbnailList) {
              const thumbnailItems = product.media.map((media, index) => {
                if (media.media_type === 'image') {
                  const isFirstImage = index === 0;
                  return `
                    <button type="button" class="product-gallery__thumbnail${isFirstImage ? ' is-selected' : ''}" data-media-id="${media.id}" aria-label="Gehe zu Element ${media.id}">
                      <img src="${media.src}" 
                           alt="${media.alt || product.title}"
                           loading="${isFirstImage ? 'eager' : 'lazy'}"
                           fetchpriority="${isFirstImage ? 'high' : 'auto'}"
                           data-width="${media.width}"
                           data-height="${media.height}"
                           sizes="(max-width: 699px) 56px, 64px"
                           srcset="${generateThumbnailSrcSet(media.src)}">
                    </button>
                  `;
                }
                return '';
              }).join('');

              thumbnailList.innerHTML = thumbnailItems;
              
              const thumbnails = thumbnailList.querySelectorAll('.product-gallery__thumbnail');
              const mediaElements = galleryContainer.querySelectorAll('.product-gallery__media');
              
              thumbnails.forEach((thumbnail, i) => {
                const mediaId = thumbnail.getAttribute('data-media-id');
                thumbnail.style.cursor = 'pointer';
                thumbnail.style.position = 'relative';
                
                const mediaIndex = Array.from(mediaElements).findIndex(
                  media => media.getAttribute('data-media-id') === mediaId
                );
                
                if (mediaIndex !== -1) {
                  
                  thumbnail.onclick = function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const mediaItems = document.querySelectorAll('.product-gallery__media');
                    const thumbnailButtons = document.querySelectorAll('.product-gallery__thumbnail');
                    
                    mediaItems.forEach(item => {
                      item.style.display = 'none';
                      item.classList.remove('is-selected');
                    });
                    
                    thumbnailButtons.forEach(btn => {
                      btn.classList.remove('is-selected');
                      btn.setAttribute('aria-current', 'false');
                    });
                    
                    if (mediaItems[mediaIndex]) {
                      const selectedMedia = mediaItems[mediaIndex];
                      selectedMedia.style.display = 'block';
                      selectedMedia.classList.add('is-selected');
                      selectedMedia.style.opacity = '1';
                      selectedMedia.style.position = 'relative';
                      
                      if (stayOnPage) {
                        selectedMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                      }
                    }
                    
                    thumbnail.classList.add('is-selected');
                    thumbnail.setAttribute('aria-current', 'true');
                    
                    const mediaCarousel = document.querySelector('media-carousel');
                    if (mediaCarousel && typeof mediaCarousel.select === 'function') {
                      mediaCarousel.setAttribute('initial-index', mediaIndex.toString());
                      try {
                        mediaCarousel.select(mediaIndex, { animate: true });
                      } catch(err) {
                        console.error('Error calling mediaCarousel.select:', err);
                      }
                    }
                    
                    return false;
                  };
                }
              });
            }
          }

          const priceContainer = document.querySelector('.product-info__price');
          if (priceContainer && product.variants && product.variants[0]) {
            const variant = product.variants[0];
            const price = variant.price;
            const compareAtPrice = variant.compare_at_price;

            const formattedPrice = new Intl.NumberFormat('de-DE', {
              style: 'currency',
              currency: 'EUR'
            }).format(price / 100);

            const salePriceElement = priceContainer.querySelector('sale-price');
            if (salePriceElement) {
              salePriceElement.textContent = formattedPrice;
            }

            const compareAtPriceElement = priceContainer.querySelector('compare-at-price');
            if (compareAtPriceElement && compareAtPrice) {
              const formattedCompareAtPrice = new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR'
              }).format(compareAtPrice / 100);
              compareAtPriceElement.textContent = formattedCompareAtPrice;
              compareAtPriceElement.removeAttribute('hidden');
            } else if (compareAtPriceElement) {
              compareAtPriceElement.setAttribute('hidden', '');
            }

            const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
            addToCartForms.forEach(form => {
              const variantInput = form.querySelector('input[name="id"]');
              if (variantInput) {
                variantInput.value = variant.id;
              }
            });
          }

          initCarousel();
        })
        .catch(error => {
          console.error('Error fetching product data:', error);
        });
    }

    swatchLinks.forEach(swatch => {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        handleSwatchChange(this);
        return false;
      });
    });
  }

  function setupCarouselObserver(mediaCarousel) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          if (mediaCarousel.style.maxHeight === '0px') {
            mediaCarousel.style.removeProperty('max-height');
            mediaCarousel.style.setProperty('height', 'auto', 'important');

            const mediaList = mediaCarousel.querySelector('.product-gallery__media-list');
            if (mediaList) {
              const actualHeight = mediaList.scrollHeight;
              mediaCarousel.style.setProperty('min-height', `${actualHeight}px`, 'important');
            }
          }
        }
      });
    });

    observer.observe(mediaCarousel, {
      attributes: true,
      attributeFilter: ['style']
    });

    return observer;
  }

  let carouselObserver = null;
}

document.addEventListener('DOMContentLoaded', function () {
  const isPremiumShaktiMat = 
    window.location.pathname.includes('/pages/premium-shakti-mat') || 
    document.querySelector('body[data-template="page.premium-shakti-mat"]') ||
    document.querySelector('[data-section-type="premium-shakti-mat/premium-scripts"]');
                             
  if (isPremiumShaktiMat) {
    const container = document.querySelector('.product-info__product-picker');
    if (container) {
      const urlParams = new URLSearchParams(window.location.search);
      const viewParam = urlParams.get('view');
      
      if (viewParam !== 'premium-shakti-mat') {
        setTimeout(() => {
          initializeProductVariations(true);
        }, 50);
      } else {
        setTimeout(() => {
          initializeProductVariations(false);
        }, 50);
      }
    }
  }
}); 